import _ from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Colors } from '~/src/scss/common/style';
import { IngredientGetDto } from '~/src/types/ingredientGetDto';
import VerticalValueLabel from '../../warehouses/inventory/components/VerticalValueLabel';
import NutritionLabelAndSearch from './NutritionLabelAndSearch';

interface BoxProps {
  unset: boolean;
}
interface Props {
  ingredient: IngredientGetDto;
  setIngredient: (ingredient: IngredientGetDto) => void;
  onClick?: () => void;
}

export default function IngredientBox({ ingredient, setIngredient, onClick }: Props): JSX.Element {
  const [showTools, setShowTools] = useState<boolean>(false);

  const unset = Object.keys(ingredient.nutritionSet).every((val) =>
    val !== 'id' ? ingredient.nutritionSet[val] === null || `${ingredient.nutritionSet[val]}`.trim() === '' : true,
  );

  const toggleTools = () => {
    setShowTools(!showTools);
  };

  return (
    <Box unset={unset}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title>
          {ingredient?.percentFromWhole} {ingredient.fdcName ?? ingredient.name}
        </Title>
        <HorizontalFlex>
          <Label>Min:</Label>
          <StyleP>{ingredient.moreThan ? ingredient.moreThan : '-'}</StyleP>
          <Label>Max:</Label>
          <StyleP>{ingredient.lessThan ? ingredient.lessThan : '-'}</StyleP>
          <Label>FDCID:</Label>
          <StyleP>{ingredient.fdcId === 0 ? ingredient.fdcId : '-'}</StyleP>
        </HorizontalFlex>
      </div>
      <ClickableBar unset={unset} onClick={onClick ?? toggleTools}>
        <HorizontalFlex>
          <VerticalValueLabel value={ingredient.nutritionSet.calories} label="Calories" />
          <VerticalValueLabel value={ingredient.nutritionSet.fat} label="Total Fat" />
          <VerticalValueLabel value={ingredient.nutritionSet.saturatedFat} label="Saturated Fat" />
          <VerticalValueLabel value={ingredient.nutritionSet.transFat} label="Trans Fat" />
          <VerticalValueLabel value={ingredient.nutritionSet.cholesterol} label="Cholesterol" />
          <VerticalValueLabel value={ingredient.nutritionSet.sodium} label="Sodium" />
          <VerticalValueLabel value={ingredient.nutritionSet.carbohydrates} label="Carbohydrates" />
          <VerticalValueLabel value={ingredient.nutritionSet.fiber} label="Dietary Fiber" />
          <VerticalValueLabel value={ingredient.nutritionSet.sugars} label="Sugars" />
          <VerticalValueLabel value={ingredient.nutritionSet.protein} label="Protein" />
        </HorizontalFlex>
      </ClickableBar>
      {showTools && (
        <>
          <NutritionLabelAndSearch
            ingredient={ingredient}
            setIngredient={setIngredient}
            // returnFood={saveToServer}
          />
        </>
      )}
    </Box>
  );
}

const StyleP = styled.p`
  position: relative;
  color: ${Colors.darkBrown};
  font-size: 14px;
  line-height: 25px;
  font-weight: 400;
  padding-right: 13px;
  margin: 0 13px 0 0;
  &:after {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #fff;
  }
`;

const Label = styled.span`
  color: #a7a7a7;
  font-size: 14px;
  line-height: 25px;
  font-weight: 700;
  margin-right: 5px;
`;

const Title = styled('span')`
  font-weight: bold;
  font-size: 20px;
  color: #343434;
  margin-bottom: 10px;
  margin-left: 5px;
  color: #343434;
`;

const Box = styled('div')<BoxProps>`
  margin: 10px;
  padding: 5px;
`;

const ClickableBar = styled('div')<BoxProps>`
  padding: 25px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #f4f4f4;
  border-radius: 10px;

  &:hover {
    filter: brightness(90%);
  }
`;

const HorizontalFlex = styled('div')`
  display: flex;
  justify-content: space-between;
`;
